/**
 * 店铺管理接口
 */
export default {
  // ---------- 梁青竹 - Start ----------
  // ---------- 梁青竹 - End ----------
  // ---------- 张敏 - Start ----------
  // 店铺管理供应商侧 店铺详情查询
  store_qryShopInfoDetail: {
    // mock: true,
    control: 'dyc/busicommon/store/qryShopInfoDetail'
  },
  // 店铺管理供应商侧 店铺创建保存
  store_saveShopInfo: {
    // mock: true,
    control: 'dyc/busicommon/store/saveShopInfo'
  },
  // 店铺管理供应商侧 店铺创建提交/变更提交
  store_createShopAuditForCc: {
    // mock: true,
    control: 'dyc/busicommon/store/createShopAuditForCc'
  },
  // 店铺管理供应商侧 店铺变更保存
  store_saveShopChangeInfo: {
    // mock: true,
    control: 'dyc/busicommon/store/saveShopChangeInfo'
  },
  // 店铺创建审批流程节点查询
  store_procNodeQry: {
    // mock: true,
    control: 'dyc/busicommon/store/procNodeQry'
  },
  // 店铺创建审批记录列表查询
  store_qryAuditLog: {
    // mock: true,
    control: 'dyc/busicommon/store/qryAuditLog'
  },
  // ---------- 张敏 - End ----------
  // ---------- 潘叙学 - Start ----------
  // 店铺管理，首页样式1布局查询
  cms_shop_style_1: {
    // mock: true,
    control: 'upload/cms/column/shop_style_one/index.html'
  },
  // 店铺管理，首页样式2布局查询
  cms_shop_style_2: {
    // mock: true,
    control: 'upload/cms/column/shop_style_two/index.html'
  },
  // 店铺管理，首页样式2布局查询-新
  cms_shop_home_style_2: {
    // mock: true,
    control: 'upload/cms/column/shop_home_style_two/index.html'
  },
  // 店铺管理，首页样式1布局查询
  cms_shop_home_style_1: {
    // mock: true,
    control: 'upload/cms/column/shop_home_style_one/index.html'
  },
  // 店铺管理，关于我们样式1布局查询
  cms_about_us_style_1: {
    // mock: true,
    control: 'upload/cms/column/about_us_style_one/index.html'
  },
  // 店铺管理，关于我们样式2布局查询
  cms_about_us_style_2: {
    // mock: true,
    control: 'upload/cms/column/about_us_style_two/index.html'
  },
  // 店铺管理，店铺装修列表查询API
  store_qryShopRenovationList: {
    // mock: true,
    control: 'dyc/busicommon/store/qryShopRenovationList'
  },
  // 店铺管理，店铺装修启停用API
  store_operShopRenovationStartAndStop: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopRenovationStartAndStop'
  },
  // 店铺管理，店铺装修页面发布API
  store_operShopRenovationRelease: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopRenovationRelease'
  },
  // 店铺管理，查询品牌列表
  commodity_queryBrandList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryBrandList'
  },
  // 店铺管理，店铺装修删除API
  store_deleteShopRenovation: {
    // mock: true,
    control: 'dyc/busicommon/store/deleteShopRenovation'
  },
  // 店铺管理，店铺装修复制API
  store_copyShopRenovationInfo: {
    // mock: true,
    control: 'dyc/busicommon/store/copyShopRenovationInfo'
  },
  // 店铺管理，店铺装修编辑确认API
  store_operShopRenovationInfo: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopRenovationInfo'
  },
  // ---------- 潘叙学 - End ----------
  // ---------- 李静 - Start ----------
  // 供应商管理（运营侧） - 店铺管理 - 店铺管理列表
  store_qryShopList: {
    // mock: true,
    control: 'dyc/busicommon/store/qryShopList'
  },
  // 店铺查询，不用登录
  store_noauth_qryShopList: {
    // mock: true,
    control: 'dyc/busicommon/store/noauth/qryShopList'
  },
  // 供应商管理（运营侧） - 店铺管理 - 解冻/冻结店铺
  store_createShopAuditForFt: {
    // mock: true,
    control: 'dyc/busicommon/store/createShopAuditForFt'
  },
  // 供应商管理（运营侧） - 店铺管理 - 店铺审批列表
  store_qryShopAuditList: {
    // mock: true,
    control: 'dyc/busicommon/store/qryShopAuditList'
  },
  // 供应商管理（运营侧） - 店铺管理 - 店铺推广
  store_qryShopOperateExtensionList: {
    // mock: true,
    control: 'dyc/busicommon/store/qryShopOperateExtensionList'
  },
  // 供应商管理（运营侧） - 店铺管理 - 店铺推广调整
  store_operShopHeatDegree: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopHeatDegree'
  },
  // 供应商管理（运营侧） - 店铺管理 - 店铺收藏列表
  store_qryShopCollectionList: {
    // mock: true,
    control: 'dyc/busicommon/store/qryShopCollectionList'
  },
  // 供应商管理（运营侧） - 店铺管理 - 收藏/取消店铺
  store_operShopCollection: {
    // mock: true,
    control: 'dyc/busicommon/user/operShopCollection'
  },
  // 供应商管理（运营侧） - 店铺管理 - 收藏/取消店铺(新)
  store_operShopCollectionNew: {
    // mock: true,
    control: 'dyc/saas/common/user/operShopCollection'
  },
  // 店铺收藏/取消查询
  store_getShopCollectionsPageList: {
    // mock: true,
    control: 'dyc/saas/common/user/getShopCollectionsPageList'
  },
  // 供应商管理（运营侧） - 店铺管理 - 收藏/取消店铺
  store_saasoperShopCollection: {
    // mock: true,
    control: 'dyc/saas/common/user/operShopCollection'
  },
  // 供应商管理（运营侧） - 店铺管理 - 查询店铺审批详情
  store_qryShopChangeInfoDetail: {
    // mock: true,
    control: 'dyc/busicommon/store/qryShopChangeInfoDetail'
  },
  // 供应商管理（运营侧） - 店铺管理 - 创建审批
  store_operShopCreateAudit: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopCreateAudit'
  },
  // 供应商管理（运营侧） - 店铺管理 - 变更审批
  store_operShopChangeAudit: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopChangeAudit'
  },
  // 供应商管理（运营侧） - 店铺管理 - 冻结审批
  store_operShopFrozenAudit: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopFrozenAudit'
  },
  // 供应商管理（运营侧） - 店铺管理 - 解冻审批
  store_operShopThawAudit: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopThawAudit'
  },
  // ---------- 李静 - End ----------
  // ---------- 张林云 - Start ----------
  // 供应商管理（运营侧） - 店铺管理 - 店铺搜索列表
  store_qryShopHomePageList: {
    // mock: true,
    control: 'dyc/busicommon/store/noauth/qryShopHomePageList'
  },
  // 供应商管理（运营侧） - 店铺管理 - 店铺筛选条件列表
  store_filterKeys: {
    // mock: true,
    control: 'dyc/busicommon/store/noauth/filterKeys'
  },
  // 供应商管理（运营侧） - 店铺管理 - 店铺搜索列表
  store_qryExcellentBusiness: {
    // mock: true,
    control: 'dyc/busicommon/store/noauth/qryExcellentBusiness'
  },
  // 供应商管理（运营侧） - 店铺管理 - 店铺搜索列表分类查询
  store_queryDropCommdType: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/queryDropCommdType'
  },
  // 供应商管理（运营侧） - 店铺管理 - 店铺搜索列表分类查询（联东新）
  store_searchBrandList: {
    // mock: true,
    control: 'dyc/busicommon/store/noauth/searchBrandList'
  },
  // ---------- 张林云 - End ----------
  // ---------- 黄露 - Start ----------
  // 店铺应用店铺装修详情查询API（改成免登）
  store_qryShopRenovationInfoDetail: {
    // mock: true,
    control: 'dyc/busicommon/store/noauth/qryShopRenovationInfoDetail'
  },
  // ---------- 黄露 - End ----------
  // 新店铺列表新增
  store_renovationPageAdd: {
    // mock: true,
    control: 'dyc/busicommon/store/renovationPageAdd'
  },
  // 新店铺列表修改
  store_operShopRenovationUpdate: {
    // mock: true,
    control: 'dyc/busicommon/store/operShopRenovationUpdate'
  },
  // 公司简介cms
  cms_shop_en_introdution: {
    // mock: true,
    control: '/upload/cms/column/en_introdution/index.html'
  },
  // 联系我们cms
  cms_shop_contact_us: {
    // mock: true,
    control: '/upload/cms/column/contact_us/index.html'
  },
  // 店铺cms头部数据获取
  cms_cmsHeader: {
    // mock: true,
    control: 'dyc/mall/commodity/noauth/cmsHeader'
  },
  // 店铺cms装修模板获取
  cms_getCanvasInfo: {
    // mock: true,
    control: 'dncp-admin/dncp/canvas/getCanvasInfo'
  },
  // 导入店铺
  store_busicommonImport: {
    // mock: true,
    control: 'dyc/busicommon/store/import'
  }
};